module.exports = angular.module('cartographer.plugin.layer.mrs-morph', [])

_ = require 'underscore'

module.exports.run $DI (
  crtLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  mrsMorphFeatureLayer
  mrsMorphEstuariesFeatureLayer
  mrsMorph5FeatureLayer
  mrsMorph10FeatureLayer
  mrsRtaFeatureLayer
  mrsRiverConditionFeatureLayer
  mrsMudSpotterLayer
  mrsWildInvadersLayer
) ->
  crtLayer.registerPlugin(mrsMorphFeatureLayer.create({
    id: "mrsMorph"
    name: "MoRPh CSci"
    atlasMapId: "mrsMorph"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorphEstuariesFeatureLayer.create({
    id: "mrsMorphEstuaries"
    name: "MoRPh Estuaries CSci"
    atlasMapId: "mrsMorphEstuaries"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorph10FeatureLayer.create({
    id: "mrsMorph10"
    name: "MoRPh 10 CSci"
    atlasMapId: "mrsMorph10"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorph5FeatureLayer.create({
    id: "mrsMorph5"
    name: "MoRPh 5 CSci"
    atlasMapId: "mrsMorph5"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsRtaFeatureLayer.create({
    id: "mrsRta"
    name: "MoRPh River Type CSci"
    atlasMapId: "mrsRta"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsRiverConditionFeatureLayer.create({
    id: "mrsRiverCondition"
    name: "MoRPh River Condition CSci"
    atlasMapId: "mrsRiverCondition"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorphFeatureLayer.create({
    id: "mrsMorphPro"
    name: "MoRPh Pro"
    atlasMapId: "mrsMorphPro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorphEstuariesFeatureLayer.create({
    id: "mrsMorphEstuariesPro"
    name: "MoRPh Estuaries Pro"
    atlasMapId: "mrsMorphEstuariesPro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorph10FeatureLayer.create({
    id: "mrsMorph10Pro"
    name: "MoRPh 10 Pro"
    atlasMapId: "mrsMorph10Pro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMorph5FeatureLayer.create({
    id: "mrsMorph5Pro"
    name: "MoRPh 5 Pro"
    atlasMapId: "mrsMorph5Pro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsRtaFeatureLayer.create({
    id: "mrsRtaPro"
    name: "MoRPh River Type Pro"
    atlasMapId: "mrsRtaPro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsRiverConditionFeatureLayer.create({
    id: "mrsRiverConditionPro"
    name: "MoRPh River Condition Pro"
    atlasMapId: "mrsRiverConditionPro"
    defaultMapEngine: "atlas"
  }))

  crtLayer.registerPlugin(mrsMudSpotterLayer)

  crtLayer.registerPlugin(mrsWildInvadersLayer)

  return

module.exports.factory "mrsMapLayerCommon", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  mrsAtpe
  mrsBedMaterialParticleSize
) ->
  nuisancePlantSpeciesAttribute = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: "A" , color: crtMarkerColor.quality(0.8) , label: "Absent (0% cover)"      }
      { value: "T" , color: crtMarkerColor.quality(0.5) , label: "Trace (1-4% cover)"     }
      { value: "P" , color: crtMarkerColor.quality(0.3) , label: "Present (5-33% cover)"  }
      { value: "E" , color: crtMarkerColor.quality(0.1) , label: "Extensive (>33% cover)" }
    ])

  particleSizeAttribute = (id, name, includeBedrock = true) ->
    bedrockValues = if includeBedrock
      [{ value: mrsBedMaterialParticleSize.Bedrock , color: crtMarkerColor.quality(0.0) , label: "Bedrock" }]
    else
      []

    crtAttributeLayer.createLookup(id, name, null, [
      bedrockValues...
      { value: mrsBedMaterialParticleSize.Boulder      , color: crtMarkerColor.quality(0.1) , label: "Boulder"       }
      { value: mrsBedMaterialParticleSize.Cobble       , color: crtMarkerColor.quality(0.3) , label: "Cobble"        }
      { value: mrsBedMaterialParticleSize.GravelPebble , color: crtMarkerColor.quality(0.5) , label: "Gravel-Pebble" }
      { value: mrsBedMaterialParticleSize.Sand         , color: crtMarkerColor.quality(0.8) , label: "Sand"          }
      { value: mrsBedMaterialParticleSize.Silt         , color: crtMarkerColor.quality(0.9) , label: "Silt"          }
      { value: mrsBedMaterialParticleSize.Clay         , color: crtMarkerColor.quality(1.0) , label: "Clay"          }
    ])

  moduleNumber =
    crtAttributeLayer.createLookup("moduleNumber", "Module Number", null, [
      { value:  1, color: crtMarkerColor.hue(0)   , label:  "1" }
      { value:  2, color: crtMarkerColor.hue(36)  , label:  "2" }
      { value:  3, color: crtMarkerColor.hue(72)  , label:  "3" }
      { value:  4, color: crtMarkerColor.hue(108) , label:  "4" }
      { value:  5, color: crtMarkerColor.hue(144) , label:  "5" }
      { value:  6, color: crtMarkerColor.hue(180) , label:  "6" }
      { value:  7, color: crtMarkerColor.hue(216) , label:  "7" }
      { value:  8, color: crtMarkerColor.hue(252) , label:  "8" }
      { value:  9, color: crtMarkerColor.hue(288) , label:  "9" }
      { value: 10, color: crtMarkerColor.hue(324) , label: "10" }
    ])

  moduleNumbers =
    crtAttributeLayer.createAutoLookup("moduleNumbers", "Module Numbers")

  surveyType =
    crtAttributeLayer.createLookup("surveyType", "SurveyType", null, [
      { value: "monitoring"     , color: crtMarkerColor.hue(40)  , label: "Monitoring"     }
      { value: "pre-project"    , color: crtMarkerColor.hue(80)  , label: "Pre-project"    }
      { value: "post-project"   , color: crtMarkerColor.hue(120) , label: "Post-project"   }
      { value: "post-recovery"  , color: crtMarkerColor.hue(160) , label: "Post-recovery"  }
      { value: "training"       , color: crtMarkerColor.hue(200) , label: "Training"       }
      { value: "scenario"       , color: crtMarkerColor.hue(240) , label: "Scenario"       }
      { value: "not-applicable" , color: crtMarkerColor.hue(280) , label: "Not applicable" }
    ])

  return {
    nuisancePlantSpeciesAttribute
    moduleNumber
    moduleNumbers
    surveyType
    particleSizeAttribute
  }

module.exports.factory "mrsMorphFeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  mrsAtpe
  mrsMapLayerCommon
  mrsFlowType
) ->
  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("general", "General", [
          crtAttributeLayer.createAutoLookup("riverName", "River")
          crtAttributeLayer.createAutoLookup("reachName", "Reach")
          crtAttributeLayer.createAutoLookup("subreachName", "Subreach")
          mrsMapLayerCommon.moduleNumber
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "MoRPh Correlation Code")
          crtAttributeLayer.createPlaceholder()
        ])
        crtFeatureLayer.createAttributeGroup("channel", "Channel Characteristics", [
          crtAttributeLayer.createThreshold("index1", "INDEX 1: Number of Flow Types", null, [
            { value: 0, color: crtMarkerColor.quality(0.0), label: "<2"   }
            { value: 2, color: crtMarkerColor.quality(0.3), label: "2 to <3" }
            { value: 3, color: crtMarkerColor.quality(0.5), label: "3 to <4" }
            { value: 4, color: crtMarkerColor.quality(0.8), label: "4 to <5" }
            { value: 5, color: crtMarkerColor.quality(1.0), label: "5+"   }
          ])
          crtAttributeLayer.createLookup("index2", "INDEX 2: Highest Energy Present/Extensive Flow Type", null, [
            { value: mrsFlowType.Dry,                   color: crtMarkerColor.quality(0.0), label: "Dry"                     }
            { value: mrsFlowType.NoPerceptableFlow,     color: crtMarkerColor.quality(0.1), label: "No perceptible flow"     }
            { value: mrsFlowType.Smooth,                color: crtMarkerColor.quality(0.2), label: "Smooth"                  }
            { value: mrsFlowType.Rippled,               color: crtMarkerColor.quality(0.3), label: "Rippled"                 }
            { value: mrsFlowType.Upwelling,             color: crtMarkerColor.quality(0.5), label: "Upwelling"               }
            { value: mrsFlowType.UnbrokenStandingWaves, color: crtMarkerColor.quality(0.6), label: "Unbroken standing waves" }
            { value: mrsFlowType.BrokenStandingWaves,   color: crtMarkerColor.quality(0.8), label: "Broken standing waves"   }
            { value: mrsFlowType.Chute,                 color: crtMarkerColor.quality(0.9), label: "Chute"                   }
            { value: mrsFlowType.FreeFall,              color: crtMarkerColor.quality(1.0), label: "Free fall"               }
          ])
          crtAttributeLayer.createThreshold("index3", "INDEX 3: Number of Bed Material Types", null, [
            { value: 0, color: crtMarkerColor.quality(0.0), label: "<2"      }
            { value: 2, color: crtMarkerColor.quality(0.1), label: "2 to <3" }
            { value: 3, color: crtMarkerColor.quality(0.3), label: "3 to <4" }
            { value: 4, color: crtMarkerColor.quality(0.5), label: "4 to <5" }
            { value: 5, color: crtMarkerColor.quality(0.8), label: "5 to <6" }
            { value: 6, color: crtMarkerColor.quality(0.9), label: "6 to <7" }
            { value: 7, color: crtMarkerColor.quality(1.0), label: "7+"      }
          ])
          mrsMapLayerCommon.particleSizeAttribute("index4", "INDEX 4: Coarsest Present/Extensive Mineral Bed Material Type", true)
          crtAttributeLayer.createThreshold("index5", "INDEX 5: Average Alluvial Bed Material Size (Phi Units)", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: "<-8"       }
            { value:  -8, color: crtMarkerColor.quality(0.1), label: "-8 to <-6" }
            { value:  -6, color: crtMarkerColor.quality(0.2), label: "-6 to <-4" }
            { value:  -4, color: crtMarkerColor.quality(0.3), label: "-4 to <-2" }
            { value:  -2, color: crtMarkerColor.quality(0.4), label: "-2 to 0"   }
            { value:   0, color: crtMarkerColor.quality(0.5), label: "0 to <2"   }
            { value:   2, color: crtMarkerColor.quality(0.6), label: "2 to <4"   }
            { value:   4, color: crtMarkerColor.quality(0.8), label: "4 to <6"   }
            { value:   6, color: crtMarkerColor.quality(0.9), label: "6 to <8"   }
            { value:   8, color: crtMarkerColor.quality(1.0), label: "8+"        }
          ])
          mrsMapLayerCommon.particleSizeAttribute("index6", "INDEX 6: Average Alluvial Bed Material Size Class", false)
          crtAttributeLayer.createThreshold("index7", "INDEX 7: Extent Of Superficial Bed Siltation", null, [
            { value: -99, color: crtMarkerColor.quality(1.0), label: "<1"   }
            { value:   1, color: crtMarkerColor.quality(0.6), label: "1 to <2" }
            { value:   2, color: crtMarkerColor.quality(0.5), label: "2 to <3" }
            { value:   3, color: crtMarkerColor.quality(0.4), label: "3 to <4" }
            { value:   4, color: crtMarkerColor.quality(0.3), label: "4 to <5" }
            { value:   5, color: crtMarkerColor.quality(0.1), label: "5 to <6" }
            { value:   6, color: crtMarkerColor.quality(0.0), label: "6+"   }
          ])
          crtAttributeLayer.createThreshold("index8", "INDEX 8: Channel Physical Habitat Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.3), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.6), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.8), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.9), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(1.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index9", "INDEX 9: Number of Aquatic Vegetation Morphotypes", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.3), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.6), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.8), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.9), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(1.0), label: '7+'   }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("riparian", "Riparian Characteristics (Bank Top and Bank Face)", [
          crtAttributeLayer.createThreshold("index10", "INDEX 10: Riparian Physical Habitat Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.5), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.8), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.9), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(1.0), label: '5+'   }
          ])
          crtAttributeLayer.createThreshold("index11", "INDEX 11: Riparian Vegetation Structural Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.2), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.3), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.4), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.5), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.6), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.8), label: '7 to <8' }
            { value:   8, color: crtMarkerColor.quality(1.0), label: '8+'   }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("human", "Human Pressures and Impacts", [
          crtAttributeLayer.createThreshold("index12", "INDEX 12: Degree of Human Pressure Imposed by Bank Top Land Cover", null, [
            { value: -99, color: crtMarkerColor.quality(0.9), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.8), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.6), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.3), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.2), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.1), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index13", "INDEX 13: Channel Reinforcement", null, [
            { value: -99, color: crtMarkerColor.quality(0.9), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.8), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.6), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.3), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.2), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.1), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index14", "INDEX 14: Non-Native Invasive Plant Species Extent", null, [
            { value: -99, color: crtMarkerColor.quality(0.8), label: "<0.5"   }
            { value: 0.5, color: crtMarkerColor.quality(0.6), label: "0.5 to <1" }
            { value: 1.0, color: crtMarkerColor.quality(0.5), label: "1 to <1.5" }
            { value: 1.5, color: crtMarkerColor.quality(0.4), label: "1.5 to <2" }
            { value: 2.0, color: crtMarkerColor.quality(0.3), label: "2 to <2.5" }
            { value: 2.5, color: crtMarkerColor.quality(0.2), label: "2.5 to <3" }
            { value: 3.0, color: crtMarkerColor.quality(0.1), label: "3 to <3.5" }
            { value: 3.5, color: crtMarkerColor.quality(0.0), label: "3.5+"   }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("nuisancePlantSpecies", "Non-Native Invasive Plants", [
          mrsMapLayerCommon.nuisancePlantSpeciesAttribute("himalayanBalsam", "Himalayan Balsam")
          mrsMapLayerCommon.nuisancePlantSpeciesAttribute("japaneseKnotweed", "Japanese Knotweed")
          mrsMapLayerCommon.nuisancePlantSpeciesAttribute("giantHogweed", "Giant Hogweed")
          mrsMapLayerCommon.nuisancePlantSpeciesAttribute("floatingPennywort", "Floating Pennywort")
        ])
      ]
    })

  return {
    create
  }

module.exports.factory "mrsMorphEstuariesFeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  mrsAtpe
  mrsMapLayerCommon
  mrsFlowType
  mrsMorphEstuariesSedimentSize
) ->
  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("general", "General", [
          crtAttributeLayer.createAutoLookup("estuaryName", "Estuary")
          crtAttributeLayer.createAutoLookup("subreachName", "Subreach")
          mrsMapLayerCommon.moduleNumber
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "Project Code")
          crtAttributeLayer.createAutoLookup("wfdWaterbodyId", "WFD Waterbody ID")
          crtAttributeLayer.createAutoLookup("surveyType", "Survey Type")
        ])
        crtFeatureLayer.createAttributeGroup("indices", "Indices (WIP)", [
          crtAttributeLayer.createThreshold("E1", "E1: Number of Present/Extensive (Exposed) Sediment Material Types", null, [
            { value: 0, color: crtMarkerColor.quality(0 / 6), label: "<2"      }
            { value: 2, color: crtMarkerColor.quality(1 / 6), label: "2 to <3" }
            { value: 3, color: crtMarkerColor.quality(2 / 6), label: "3 to <4" }
            { value: 4, color: crtMarkerColor.quality(3 / 6), label: "4 to <5" }
            { value: 5, color: crtMarkerColor.quality(4 / 6), label: "5 to <6" }
            { value: 6, color: crtMarkerColor.quality(5 / 6), label: "6 to <7" }
            { value: 7, color: crtMarkerColor.quality(6 / 6), label: "7+"      }
          ])
          crtAttributeLayer.createLookup("E2", "E2: Coarsest Present/Extensive Mineral Sediment Material Type", null, [
            { value: mrsMorphEstuariesSedimentSize.Bedrock       , color: crtMarkerColor.hue(7 / 8 * 360) , label: "Bedrock"         }
            { value: mrsMorphEstuariesSedimentSize.Boulder       , color: crtMarkerColor.hue(6 / 8 * 360) , label: "Boulder"         }
            { value: mrsMorphEstuariesSedimentSize.Cobble        , color: crtMarkerColor.hue(5 / 8 * 360) , label: "Cobble"          }
            { value: mrsMorphEstuariesSedimentSize.GravelPebble  , color: crtMarkerColor.hue(4 / 8 * 360) , label: "Gravel-Pebble"   }
            { value: mrsMorphEstuariesSedimentSize.ShellyMaterial, color: crtMarkerColor.hue(3 / 8 * 360) , label: "Shelly Material" }
            { value: mrsMorphEstuariesSedimentSize.Sand          , color: crtMarkerColor.hue(2 / 8 * 360) , label: "Sand"            }
            { value: mrsMorphEstuariesSedimentSize.FineSediments , color: crtMarkerColor.hue(1 / 8 * 360) , label: "Fine Sediments"  }
            { value: mrsMorphEstuariesSedimentSize.FluidMud      , color: crtMarkerColor.hue(0 / 8 * 360) , label: "Fluid Mud"       }
          ])
          crtAttributeLayer.createRange("E3", "E3: Estuary Margin Profile", null, [
            { minValue: 66       , maxValue: undefined, color: crtMarkerColor.quality(7 / 7) }
            { minValue: 40       , maxValue: 66       , color: crtMarkerColor.quality(6 / 7) }
            { minValue: 18       , maxValue: 40       , color: crtMarkerColor.quality(5 / 7) }
            { minValue: 1        , maxValue: 18       , color: crtMarkerColor.quality(4 / 7) }
            { minValue: -20      , maxValue: 1        , color: crtMarkerColor.quality(3 / 7) }
            { minValue: -100     , maxValue: -20      , color: crtMarkerColor.quality(2 / 7) }
            { minValue: -250     , maxValue: -100     , color: crtMarkerColor.quality(1 / 7) }
            { minValue: undefined, maxValue: -250     , color: crtMarkerColor.quality(0 / 7) }
          ])
          crtAttributeLayer.createRange("E4", "E4: Marginal Habitat Richness for Biota", null, [
            { minValue: undefined, maxValue: 3        , color: crtMarkerColor.quality( 5 / 10) }
            { minValue: 3        , maxValue: 6        , color: crtMarkerColor.quality( 6 / 10) }
            { minValue: 6        , maxValue: 9        , color: crtMarkerColor.quality( 7 / 10) }
            { minValue: 9        , maxValue: 12       , color: crtMarkerColor.quality( 8 / 10) }
            { minValue: 12       , maxValue: 15       , color: crtMarkerColor.quality( 9 / 10) }
            { minValue: 15       , maxValue: undefined, color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E5", "E5: Subtidal & Unvegetated Intertidal Physical Habitat Complexity", null, [
            { minValue: 0, maxValue: 1        , color: crtMarkerColor.quality(0 / 6) }
            { minValue: 1, maxValue: 2        , color: crtMarkerColor.quality(1 / 6) }
            { minValue: 2, maxValue: 3        , color: crtMarkerColor.quality(2 / 6) }
            { minValue: 3, maxValue: 4        , color: crtMarkerColor.quality(3 / 6) }
            { minValue: 4, maxValue: 5        , color: crtMarkerColor.quality(4 / 6) }
            { minValue: 5, maxValue: 6        , color: crtMarkerColor.quality(5 / 6) }
            { minValue: 6, maxValue: undefined, color: crtMarkerColor.quality(6 / 6) }
          ])
          crtAttributeLayer.createRange("E6", "E6: Vegetated Intertidal Natural Features Richness (Physical Habitat Complexity)", null, [
            { minValue:  0, maxValue:  2       , color: crtMarkerColor.quality( 5 / 10) }
            { minValue:  2, maxValue:  4       , color: crtMarkerColor.quality( 6 / 10) }
            { minValue:  4, maxValue:  6       , color: crtMarkerColor.quality( 7 / 10) }
            { minValue:  6, maxValue:  8       , color: crtMarkerColor.quality( 8 / 10) }
            { minValue:  8, maxValue: 10       , color: crtMarkerColor.quality( 9 / 10) }
            { minValue: 10, maxValue: undefined, color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E7", "E7: Supratidal & Riparian Physical Habitat Complexity", null, [
            { minValue:  0, maxValue:  2       , color: crtMarkerColor.quality( 5 / 10) }
            { minValue:  2, maxValue:  4       , color: crtMarkerColor.quality( 6 / 10) }
            { minValue:  4, maxValue:  6       , color: crtMarkerColor.quality( 7 / 10) }
            { minValue:  6, maxValue:  8       , color: crtMarkerColor.quality( 8 / 10) }
            { minValue:  8, maxValue: 10       , color: crtMarkerColor.quality( 9 / 10) }
            { minValue: 10, maxValue: undefined, color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E8", "E8: Degree of Human Pressure Imposed by Supratidal Land Cover", null, [
            { minValue: undefined, maxValue: -20      , color: crtMarkerColor.quality( 0 / 7) }
            { minValue:       -20, maxValue: -15      , color: crtMarkerColor.quality( 1 / 7) }
            { minValue:       -15, maxValue: -10      , color: crtMarkerColor.quality( 2 / 7) }
            { minValue:       -10, maxValue: -8       , color: crtMarkerColor.quality( 3 / 7) }
            { minValue:        -8, maxValue: -6       , color: crtMarkerColor.quality( 4 / 7) }
            { minValue:        -6, maxValue: -4       , color: crtMarkerColor.quality( 5 / 7) }
            { minValue:        -4, maxValue: -2       , color: crtMarkerColor.quality( 6 / 7) }
            { minValue:        -2, maxValue:  0       , color: crtMarkerColor.quality( 7 / 7) }
          ])
          crtAttributeLayer.createRange("E9", "E9: Channel Reinforcement", null, [
            { minValue: undefined, maxValue: -10, color: crtMarkerColor.quality( 0 / 10) }
            { minValue: -10      , maxValue: -8 , color: crtMarkerColor.quality( 2 / 10) }
            { minValue:  -8      , maxValue: -6 , color: crtMarkerColor.quality( 4 / 10) }
            { minValue:  -6      , maxValue: -4 , color: crtMarkerColor.quality( 6 / 10) }
            { minValue:  -4      , maxValue: -2 , color: crtMarkerColor.quality( 8 / 10) }
            { minValue:  -2      , maxValue:  0 , color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E10", "E10: Vegetated Intertidal Signs of Erosion", null, [
            { minValue: undefined, maxValue: -10, color: crtMarkerColor.quality( 0 / 10) }
            { minValue: -10      , maxValue: -8 , color: crtMarkerColor.quality( 2 / 10) }
            { minValue:  -8      , maxValue: -6 , color: crtMarkerColor.quality( 4 / 10) }
            { minValue:  -6      , maxValue: -4 , color: crtMarkerColor.quality( 6 / 10) }
            { minValue:  -4      , maxValue: -2 , color: crtMarkerColor.quality( 8 / 10) }
            { minValue:  -2      , maxValue:  0 , color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E11", "E11: Terrestrial Non-Native Invasive Plant Extent", null, [
            { minValue: undefined, maxValue: -10, color: crtMarkerColor.quality( 0 / 10) }
            { minValue: -10      , maxValue: -8 , color: crtMarkerColor.quality( 2 / 10) }
            { minValue:  -8      , maxValue: -6 , color: crtMarkerColor.quality( 4 / 10) }
            { minValue:  -6      , maxValue: -4 , color: crtMarkerColor.quality( 6 / 10) }
            { minValue:  -4      , maxValue: -2 , color: crtMarkerColor.quality( 8 / 10) }
            { minValue:  -2      , maxValue:  0 , color: crtMarkerColor.quality(10 / 10) }
          ])
          crtAttributeLayer.createRange("E12", "E12: Litter", null, [
            { minValue: undefined, maxValue: -30, color: crtMarkerColor.quality(0 / 9) }
            { minValue: -30      , maxValue: -25, color: crtMarkerColor.quality(1 / 9) }
            { minValue: -25      , maxValue: -20, color: crtMarkerColor.quality(2 / 9) }
            { minValue: -20      , maxValue: -15, color: crtMarkerColor.quality(3 / 9) }
            { minValue: -15      , maxValue: -10, color: crtMarkerColor.quality(4 / 9) }
            { minValue: -10      , maxValue:  -8, color: crtMarkerColor.quality(5 / 9) }
            { minValue:  -8      , maxValue:  -6, color: crtMarkerColor.quality(6 / 9) }
            { minValue:  -6      , maxValue:  -4, color: crtMarkerColor.quality(7 / 9) }
            { minValue:  -4      , maxValue:  -2, color: crtMarkerColor.quality(8 / 9) }
            { minValue:  -2      , maxValue:   0, color: crtMarkerColor.quality(9 / 9) }
          ])
        ])
      ]
    })

  return {
    create
  }

module.exports.factory "mrsMorph5FeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  mrsMapLayerCommon
) ->
  negativeIndex = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: -4 , color: crtMarkerColor.quality(0 / 8), label: "-4" }
      { value: -3 , color: crtMarkerColor.quality(1 / 8), label: "-3" }
      { value: -2 , color: crtMarkerColor.quality(2 / 8), label: "-2" }
      { value: -1 , color: crtMarkerColor.quality(3 / 8), label: "-1" }
      { value:  0 , color: crtMarkerColor.quality(4 / 8), label:  "0" }
    ])

  positiveIndex = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: 0 , color: crtMarkerColor.quality(4 / 8 ), label: "0" }
      { value: 1 , color: crtMarkerColor.quality(5 / 8 ), label: "1" }
      { value: 2 , color: crtMarkerColor.quality(6 / 8 ), label: "2" }
      { value: 3 , color: crtMarkerColor.quality(7 / 8 ), label: "3" }
      { value: 4 , color: crtMarkerColor.quality(8 / 8 ), label: "4" }
    ])

  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("surveyDetails", "Survey Details", [
          crtAttributeLayer.createAutoLookup("riverName", "River")
          crtAttributeLayer.createAutoLookup("reachName", "Reach")
          crtAttributeLayer.createAutoLookup("subreachName", "Subreach")
          mrsMapLayerCommon.moduleNumbers
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "MoRPh Correlation Code")
          mrsMapLayerCommon.surveyType
          crtAttributeLayer.createAutoLookup("scenarioName", "Scenario")
        ])
        crtFeatureLayer.createAttributeGroup("riverCondition", "River Condition", [
          crtAttributeLayer.createRange("preliminaryConditionScore", "Condition Score (Preliminary)", null, [
            { minValue: -5, maxValue: -4, color: crtMarkerColor.quality(0.0) }
            { minValue: -4, maxValue: -3, color: crtMarkerColor.quality(0.1) }
            { minValue: -3, maxValue: -2, color: crtMarkerColor.quality(0.2) }
            { minValue: -2, maxValue: -1, color: crtMarkerColor.quality(0.3) }
            { minValue: -1, maxValue:  0, color: crtMarkerColor.quality(0.4) }
            { minValue:  0, maxValue:  1, color: crtMarkerColor.quality(0.5) }
            { minValue:  1, maxValue:  2, color: crtMarkerColor.quality(0.6) }
            { minValue:  2, maxValue:  3, color: crtMarkerColor.quality(0.7) }
            { minValue:  3, maxValue:  4, color: crtMarkerColor.quality(0.8) }
            { minValue:  4, maxValue:  5, color: crtMarkerColor.quality(0.9) }
          ])
          crtAttributeLayer.createRange("PositiveIndexAverage", "Average of Positive Indicators", null, [
            { minValue:  0, maxValue:  1, color: crtMarkerColor.quality(0.5) }
            { minValue:  1, maxValue:  2, color: crtMarkerColor.quality(0.6) }
            { minValue:  2, maxValue:  3, color: crtMarkerColor.quality(0.7) }
            { minValue:  3, maxValue:  4, color: crtMarkerColor.quality(0.8) }
            { minValue:  4, maxValue:  5, color: crtMarkerColor.quality(0.9) }
          ])
          crtAttributeLayer.createRange("NegativeIndexAverage", "Average of Negative Indicators", null, [
            { minValue: -5, maxValue: -4, color: crtMarkerColor.quality(0.0) }
            { minValue: -4, maxValue: -3, color: crtMarkerColor.quality(0.1) }
            { minValue: -3, maxValue: -2, color: crtMarkerColor.quality(0.2) }
            { minValue: -2, maxValue: -1, color: crtMarkerColor.quality(0.3) }
            { minValue: -1, maxValue:  0, color: crtMarkerColor.quality(0.4) }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("dimensions", "Dimensions", [
          crtAttributeLayer.createRange("shape", "River Shape", null, [
            { minValue:  0.0, maxValue:       0.5, color: crtMarkerColor.numeric(0/6) }
            { minValue:  0.5, maxValue:       1.0, color: crtMarkerColor.numeric(1/6) }
            { minValue:  1.0, maxValue:       1.5, color: crtMarkerColor.numeric(2/6) }
            { minValue:  1.5, maxValue:       2.0, color: crtMarkerColor.numeric(3/6) }
            { minValue:  2.0, maxValue:       5.0, color: crtMarkerColor.numeric(4/6) }
            { minValue:  5.0, maxValue:      10.0, color: crtMarkerColor.numeric(5/6) }
            { minValue: 10.0, maxValue: undefined, color: crtMarkerColor.numeric(6/6) }
          ])
          crtAttributeLayer.createRange("averageWidth", "Average Width", "m", [
            { minValue:  0.0, maxValue:       1.0, color: crtMarkerColor.numeric(0/6) }
            { minValue:  1.0, maxValue:       2.0, color: crtMarkerColor.numeric(1/6) }
            { minValue:  2.0, maxValue:       3.0, color: crtMarkerColor.numeric(2/6) }
            { minValue:  3.0, maxValue:       5.0, color: crtMarkerColor.numeric(3/6) }
            { minValue:  5.0, maxValue:      10.0, color: crtMarkerColor.numeric(4/6) }
            { minValue: 10.0, maxValue:      20.0, color: crtMarkerColor.numeric(5/6) }
            { minValue: 20.0, maxValue: undefined, color: crtMarkerColor.numeric(6/6) }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("A", "Group A", [
          crtAttributeLayer.createAutoLookup("A6", "A6: Bedrock Reaches")
          mrsMapLayerCommon.particleSizeAttribute("A7", "A7: Coarsest Bed Material Size Class", true)
          mrsMapLayerCommon.particleSizeAttribute("A8", "A8: Average Alluvial Bed Material Size Class", false)
        ])
        crtFeatureLayer.createAttributeGroup("B", "Group B", [
          positiveIndex("B1", "B1: Bank Top Vegetation Structure")
          positiveIndex("B2", "B2: Bank Top Tree Feature Richness")
          positiveIndex("B3", "B3: Bank Top Water-Related Features")
          negativeIndex("B4", "B4: Bank Top NNIPS Cover")
          negativeIndex("B5", "B5: Bank Top Managed Ground Cover")
        ])
        # crtFeatureLayer.createAttributeGroup("B", "Group B (Unnormalized)", [
        #   crtAttributeLayer.createAutoThreshold("B1U", "B1U: Bank Top Vegetation Structure (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("B2U", "B2U: Bank Top Tree Feature Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("B3U", "B3U: Bank Top Water-Related Features (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("B4U", "B4U: Bank Top NNIPS Cover (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("B5U", "B5U: Bank Top Managed Ground Cover (Unnormalized)")
        # ])
        crtFeatureLayer.createAttributeGroup("C", "Group C", [
          positiveIndex("C1", "C1: Bank Face Riparian Vegetation Structure")
          positiveIndex("C2", "C2: Bank Face Tree Feature Richness")
          positiveIndex("C3", "C3: Bank Face Natural Bank Profile Extent")
          positiveIndex("C4", "C4: Bank Face Natural Bank Profile Richness")
          positiveIndex("C5", "C5: Bank Face Natural Bank Material Richness")
          positiveIndex("C6", "C6: Bank Face Bare Sediment Extent")
          negativeIndex("C7", "C7: Bank Face Artificial Bank Profile Extent")
          negativeIndex("C8", "C8: Bank Face Reinforcement Extent")
          negativeIndex("C9", "C9: Bank Face Reinforcement Material Severity")
          negativeIndex("C10", "C10: Bank Face NNIPS Cover")
        ])
        # crtFeatureLayer.createAttributeGroup("C", "Group C (Unnormalized)", [
        #   crtAttributeLayer.createAutoThreshold("C1U", "C1U: Bank Face Riparian Vegetation Structure (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C2U", "C2U: Bank Face Tree Feature Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C3U", "C3U: Bank Face Natural Bank Profile Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C4U", "C4U: Bank Face Natural Bank Profile Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C5U", "C5U: Bank Face Natural Bank Material Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C6U", "C6U: Bank Face Bare Sediment Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C7U", "C7U: Bank Face Artificial Bank Profile Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C8U", "C8U: Bank Face Reinforcement Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C9U", "C9U: Bank Face Reinforcement Material Severity (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("C10U", "C10U: Bank Face NNIPS Cover (Unnormalized)")
        # ])
        crtFeatureLayer.createAttributeGroup("D", "Group D", [
          positiveIndex("D1", "D1: Channel Margin Aquatic Vegetation Extent")
          positiveIndex("D2", "D2: Channel Margin Aquatic Morphotype Richness")
          positiveIndex("D3", "D3: Channel Margin Physical Feature Extent")
          positiveIndex("D4", "D4: Channel Margin Physical Feature Richness")
          negativeIndex("D5", "D5: Channel Margin Artificial Features")
        ])
        # crtFeatureLayer.createAttributeGroup("D", "Group D (Unnormalized)", [
        #   crtAttributeLayer.createAutoThreshold("D1U", "D1U: Channel Margin Aquatic Vegetation Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("D2U", "D2U: Channel Margin Aquatic Morphotype Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("D3U", "D3U: Channel Margin Physical Feature Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("D4U", "D4U: Channel Margin Physical Feature Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("D5U", "D5U: Channel Margin Artificial Features (Unnormalized)")
        # ])
        crtFeatureLayer.createAttributeGroup("E", "Group E", [
          positiveIndex("E1", "E1: Channel Aquatic Morphotype Richness")
          positiveIndex("E2", "E2: Channel Bed Tree Features Richness")
          positiveIndex("E3", "E3: Channel Bed Hydraulic Features Richness")
          positiveIndex("E4", "E4: Channel Bed Natural Features Extent")
          positiveIndex("E5", "E5: Channel Bed Natural Features Richness")
          positiveIndex("E6", "E6: Channel Bed Material Richness")
          negativeIndex("E7", "E7: Channel Bed Siltation")
          negativeIndex("E8", "E8: Channel Bed Reinforcement Extent")
          negativeIndex("E9", "E9: Channel Bed Reinforcement Severity")
          negativeIndex("E10", "E10: Channel Bed Artificial Features Severity")
          negativeIndex("E11", "E11: Channel Bed NNIPS Extent")
          negativeIndex("E12", "E12: Channel Bed Filamentous Algae Extent")
        ])
        # crtFeatureLayer.createAttributeGroup("E", "Group E (Unnormalized)", [
        #   crtAttributeLayer.createAutoThreshold("E1U", "E1U: Channel Aquatic Morphotype Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E2U", "E2U: Channel Bed Tree Features Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E3U", "E3U: Channel Bed Hydraulic Features Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E4U", "E4U: Channel Bed Natural Features Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E5U", "E5U: Channel Bed Natural Features Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E6U", "E6U: Channel Bed Material Richness (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E7U", "E7U: Channel Bed Siltation (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E8U", "E8U: Channel Bed Reinforcement Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E9U", "E9U: Channel Bed Reinforcement Severity (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E10U", "E10U: Channel Bed Artificial Features Severity (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E11U", "E11U: Channel Bed NNIPS Extent (Unnormalized)")
        #   crtAttributeLayer.createAutoThreshold("E12U", "E12U: Channel Bed Filamentous Algae Extent (Unnormalized)")
        # ])
      ]
    })

  return {
    create
  }

module.exports.factory "mrsMorph10FeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMapPermissionModel
  crtMarkerColor
  mrsMapLayerCommon
  mrsFlowType
) ->
  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("extra", "Survey Details", [
          crtAttributeLayer.createAutoLookup("riverName", "River")
          crtAttributeLayer.createAutoLookup("reachName", "Reach")
          crtAttributeLayer.createAutoLookup("subreachName", "Subreach")
          mrsMapLayerCommon.moduleNumbers
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "MoRPh Correlation Code")
          crtAttributeLayer.createPlaceholder()
        ])
        crtFeatureLayer.createAttributeGroup("channel", "Channel Characteristics", [
          crtAttributeLayer.createThreshold("index1", "INDEX 1: Number of Present/Extensive Flow Types", null, [
            { value: 0, color: crtMarkerColor.quality(0.0), label: "<2"   }
            { value: 2, color: crtMarkerColor.quality(0.3), label: "2 to <3" }
            { value: 3, color: crtMarkerColor.quality(0.5), label: "3 to <4" }
            { value: 4, color: crtMarkerColor.quality(0.8), label: "4 to <5" }
            { value: 5, color: crtMarkerColor.quality(1.0), label: "5+"   }
          ])
          crtAttributeLayer.createLookup("index2", "INDEX 2: Highest Energy Present/Extensive Flow Type", null, [
            { value: mrsFlowType.Dry,                   color: crtMarkerColor.quality(0.0), label: "Dry"                     }
            { value: mrsFlowType.NoPerceptableFlow,     color: crtMarkerColor.quality(0.1), label: "No perceptible flow"     }
            { value: mrsFlowType.Smooth,                color: crtMarkerColor.quality(0.2), label: "Smooth"                  }
            { value: mrsFlowType.Rippled,               color: crtMarkerColor.quality(0.3), label: "Rippled"                 }
            { value: mrsFlowType.Upwelling,             color: crtMarkerColor.quality(0.5), label: "Upwelling"               }
            { value: mrsFlowType.UnbrokenStandingWaves, color: crtMarkerColor.quality(0.6), label: "Unbroken standing waves" }
            { value: mrsFlowType.BrokenStandingWaves,   color: crtMarkerColor.quality(0.8), label: "Broken standing waves"   }
            { value: mrsFlowType.Chute,                 color: crtMarkerColor.quality(0.9), label: "Chute"                   }
            { value: mrsFlowType.FreeFall,              color: crtMarkerColor.quality(1.0), label: "Free fall"               }
          ])
          crtAttributeLayer.createThreshold("index3", "INDEX 3: Number of Present/Extensive Bed Material Types", null, [
            { value: 0, color: crtMarkerColor.quality(0.0), label: "<2"   }
            { value: 2, color: crtMarkerColor.quality(0.1), label: "2 to <3" }
            { value: 3, color: crtMarkerColor.quality(0.3), label: "3 to <4" }
            { value: 4, color: crtMarkerColor.quality(0.5), label: "4 to <5" }
            { value: 5, color: crtMarkerColor.quality(0.8), label: "5 to <6" }
            { value: 6, color: crtMarkerColor.quality(0.9), label: "6 to <7" }
            { value: 7, color: crtMarkerColor.quality(1.0), label: "7+"   }
          ])
          mrsMapLayerCommon.particleSizeAttribute("index4", "INDEX 4: Coarsest Present/Extensive Mineral Bed Material Type", true)
          crtAttributeLayer.createThreshold("index5", "INDEX 5: Average Alluvial Bed Material Size (Phi Units)", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: "<-8"    }
            { value:  -8, color: crtMarkerColor.quality(0.1), label: "-8 to <-6" }
            { value:  -6, color: crtMarkerColor.quality(0.2), label: "-6 to <-4" }
            { value:  -4, color: crtMarkerColor.quality(0.3), label: "-4 to <-2" }
            { value:  -2, color: crtMarkerColor.quality(0.4), label: "-2 to 0"   }
            { value:   0, color: crtMarkerColor.quality(0.5), label: "0 to <2"   }
            { value:   2, color: crtMarkerColor.quality(0.6), label: "2 to <4"   }
            { value:   4, color: crtMarkerColor.quality(0.8), label: "4 to <6"   }
            { value:   6, color: crtMarkerColor.quality(0.9), label: "6 to <8"   }
            { value:   8, color: crtMarkerColor.quality(1.0), label: "8+"     }
          ])
          mrsMapLayerCommon.particleSizeAttribute("index6", "INDEX 6: Average Alluvial Bed Material Size Class", false)
          crtAttributeLayer.createThreshold("index7", "INDEX 7: Extent of Superficial Bed Siltation", null, [
            { value: -99, color: crtMarkerColor.quality(1.0), label: "<1"   }
            { value:   1, color: crtMarkerColor.quality(0.6), label: "1 to <2" }
            { value:   2, color: crtMarkerColor.quality(0.5), label: "2 to <3" }
            { value:   3, color: crtMarkerColor.quality(0.4), label: "3 to <4" }
            { value:   4, color: crtMarkerColor.quality(0.3), label: "4 to <5" }
            { value:   5, color: crtMarkerColor.quality(0.1), label: "5 to <6" }
            { value:   6, color: crtMarkerColor.quality(0.0), label: "6+"   }
          ])
          crtAttributeLayer.createThreshold("index8", "INDEX 8: Channel Physical Habitat Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.3), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.6), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.8), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.9), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(1.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index9", "INDEX 9: Number of Aquatic Vegetation Morphotypes", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.3), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.6), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.8), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.9), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(1.0), label: '7+'   }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("riparian", "Riparian Characteristics (Bank Face and Bank Top)", [
          crtAttributeLayer.createThreshold("index10", "INDEX 10: Average Riparian Physical Habitat Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.5), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.8), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.9), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(1.0), label: '5+'   }
          ])
          crtAttributeLayer.createThreshold("index11", "INDEX 11: Maximum Riparian Physical Habitat Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.5), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.8), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.9), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(1.0), label: '5+'   }
          ])
          crtAttributeLayer.createThreshold("index12", "INDEX 12: Riparian Vegetation Structural Complexity", null, [
            { value: -99, color: crtMarkerColor.quality(0.0), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.1), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.2), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.3), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.4), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.5), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.6), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.8), label: '7 to <8' }
            { value:   8, color: crtMarkerColor.quality(1.0), label: '8+'   }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("human", "Human Pressures and Impacts", [
          crtAttributeLayer.createThreshold("index13", "INDEX 13: Degree of Human Pressure Imposed by Bank Top Land Cover", null, [
            { value: -99, color: crtMarkerColor.quality(0.9), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.8), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.6), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.3), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.2), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.1), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index14", "INDEX 14: Channel Reinforcement", null, [
            { value: -99, color: crtMarkerColor.quality(0.9), label: '<1'   }
            { value:   1, color: crtMarkerColor.quality(0.8), label: '1 to <2' }
            { value:   2, color: crtMarkerColor.quality(0.6), label: '2 to <3' }
            { value:   3, color: crtMarkerColor.quality(0.5), label: '3 to <4' }
            { value:   4, color: crtMarkerColor.quality(0.3), label: '4 to <5' }
            { value:   5, color: crtMarkerColor.quality(0.2), label: '5 to <6' }
            { value:   6, color: crtMarkerColor.quality(0.1), label: '6 to <7' }
            { value:   7, color: crtMarkerColor.quality(0.0), label: '7+'   }
          ])
          crtAttributeLayer.createThreshold("index15", "INDEX 15: Non-Native Invasive Plant Species Extent", null, [
            { value: -99, color: crtMarkerColor.quality(0.8), label: "<0.5"   }
            { value: 0.5, color: crtMarkerColor.quality(0.6), label: "0.5 to <1" }
            { value: 1.0, color: crtMarkerColor.quality(0.5), label: "1 to <1.5" }
            { value: 1.5, color: crtMarkerColor.quality(0.4), label: "1.5 to <2" }
            { value: 2.0, color: crtMarkerColor.quality(0.3), label: "2 to <2.5" }
            { value: 2.5, color: crtMarkerColor.quality(0.2), label: "2.5 to <3" }
            { value: 3.0, color: crtMarkerColor.quality(0.1), label: "3 to <3.5" }
            { value: 3.5, color: crtMarkerColor.quality(0.0), label: "3.5+"   }
          ])
          crtAttributeLayer.createThreshold("index16", "INDEX 16: Number of Non-Native Invasive Plant Species", null, [
            { value:   0, color: crtMarkerColor.quality(0.8), label: "0" }
            { value:   1, color: crtMarkerColor.quality(0.5), label: "1" }
            { value:   2, color: crtMarkerColor.quality(0.4), label: "2" }
            { value:   3, color: crtMarkerColor.quality(0.3), label: "3" }
            { value:   4, color: crtMarkerColor.quality(0.2), label: "4" }
            { value:   5, color: crtMarkerColor.quality(0.1), label: "5" }
            { value:   6, color: crtMarkerColor.quality(0.0), label: "6" }
          ])
        ])
      ]
    })

  return {
    create
  }

module.exports.factory "mrsRtaFeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapPermissionModel
  mrsMapLayerCommon
  mrsRtaRiverCategory
  mrsRtaRiverType
  mrsRtaConditionClass
  mrsRtaLevelOfConfinement
) ->
  createRiverTypeAttribute = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: mrsRtaRiverType.Navigable , color: crtMarkerColor.create("#777")   , label: "Navigable" }
      { value: mrsRtaRiverType.Large     , color: crtMarkerColor.create("#eee")   , label: "Large" }
      { value: mrsRtaRiverType.A         , color: crtMarkerColor.hue(Math.floor(360 * 0  / 12)) , label: "Type A" }
      { value: mrsRtaRiverType.B         , color: crtMarkerColor.hue(Math.floor(360 * 1  / 12)) , label: "Type B" }
      { value: mrsRtaRiverType.C         , color: crtMarkerColor.hue(Math.floor(360 * 2  / 12)) , label: "Type C" }
      { value: mrsRtaRiverType.D         , color: crtMarkerColor.hue(Math.floor(360 * 3  / 12)) , label: "Type D" }
      { value: mrsRtaRiverType.E         , color: crtMarkerColor.hue(Math.floor(360 * 4  / 12)) , label: "Type E" }
      { value: mrsRtaRiverType.F         , color: crtMarkerColor.hue(Math.floor(360 * 5  / 12)) , label: "Type F" }
      { value: mrsRtaRiverType.G         , color: crtMarkerColor.hue(Math.floor(360 * 6  / 12)) , label: "Type G" }
      { value: mrsRtaRiverType.H         , color: crtMarkerColor.hue(Math.floor(360 * 7  / 12)) , label: "Type H" }
      { value: mrsRtaRiverType.I         , color: crtMarkerColor.hue(Math.floor(360 * 8  / 12)) , label: "Type I" }
      { value: mrsRtaRiverType.J         , color: crtMarkerColor.hue(Math.floor(360 * 9  / 12)) , label: "Type J" }
      { value: mrsRtaRiverType.K         , color: crtMarkerColor.hue(Math.floor(360 * 10 / 12)) , label: "Type K" }
      { value: mrsRtaRiverType.L         , color: crtMarkerColor.hue(Math.floor(360 * 11 / 12)) , label: "Type L" }
      { value: mrsRtaRiverType.M         , color: crtMarkerColor.hue(Math.floor(360 * 12 / 12)) , label: "Type M" }
    ])

  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("surveyDetails", "Survey Details", [
          crtAttributeLayer.createAutoLookup("riverName", "River")
          crtAttributeLayer.createAutoLookup("reachName", "Reach")
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "MoRPh Correlation Code")
          crtAttributeLayer.createAutoLookup("wfdWaterBodyId", "WFD Water Body ID")
        ])
        crtFeatureLayer.createAttributeGroup("finalRiverType", "River Type", [
          createRiverTypeAttribute("finalRiverType", "River Type")
        ])
        crtFeatureLayer.createAttributeGroup("calculations", "Calculations", [
          crtAttributeLayer.createLookup("riverCategory", "River Category", null, [
            { value: mrsRtaRiverCategory.Navigable , color: crtMarkerColor.create("#777") , label: "Navigable" }
            { value: mrsRtaRiverCategory.Large     , color: crtMarkerColor.create("#eee") , label: "Large" }
            { value: mrsRtaRiverCategory.Other     , color: crtMarkerColor.create("#0dd") , label: "Other" }
          ])
          crtAttributeLayer.createRange("a1", "A1: Braiding Index", null, [
            { minValue: undefined , maxValue: 1.1       , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.1       , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createRange("a2", "A2: Sinuosity Index", null, [
            { minValue: undefined , maxValue: 1.05      , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.05      , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createRange("a3", "A3: Anabranching Index", null, [
            { minValue: undefined , maxValue: 1.05      , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.05      , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createLookup("a4", "A4: Level of Confinement", null, [
            { value: mrsRtaLevelOfConfinement.Confined       , color: crtMarkerColor.quality(4 / 12) , label: "Confined" }
            { value: mrsRtaLevelOfConfinement.PartlyConfined , color: crtMarkerColor.quality(5 / 12) , label: "Partly confined" }
            { value: mrsRtaLevelOfConfinement.Unconfined     , color: crtMarkerColor.quality(6 / 12)  , label: "Unconfined" }
          ])
          crtAttributeLayer.createRange("a5", "A5: Reach Valley Gradient", null, [
            { minValue: undefined , maxValue: 0.01      , color: crtMarkerColor.quality(4 / 12) }
            { minValue: 0.01      , maxValue: undefined , color: crtMarkerColor.quality(6 / 12) }
          ])
          crtAttributeLayer.createAutoLookup("a6", "A6: Bedrock Reach?")
          mrsMapLayerCommon.particleSizeAttribute("a7", "A7: Coarsest Bed Material", true)
          mrsMapLayerCommon.particleSizeAttribute("a8", "A8: Average Bed Material", false)
          createRiverTypeAttribute("calculatedRiverType", "Calculated River Type")
          createRiverTypeAttribute("overriddenRiverType", "Overridden River Type")
        ])
      ]
    })

  return {
    createRiverTypeAttribute
    create
  }

module.exports.factory "mrsRiverConditionFeatureLayer", $DI (
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapPermissionModel
  mrsMapLayerCommon
  mrsRtaRiverCategory
  mrsRtaRiverType
  mrsRtaConditionClass
  mrsRtaLevelOfConfinement
  mrsRtaFeatureLayer
) ->
  create = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: 10
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup("surveyDetails", "Survey Details", [
          crtAttributeLayer.createAutoLookup("riverName", "River")
          crtAttributeLayer.createAutoLookup("reachName", "Reach")
          crtAttributeLayer.createAutoLookup("subreachName", "Subreach")
          mrsMapLayerCommon.moduleNumbers
          crtAttributeLayer.createAutoLookup("wfdWaterBodyId", "WFD Water Body ID")
          crtAttributeLayer.createAutoLookup("projectName", "Project Name")
          crtAttributeLayer.createAutoLookup("projectCode", "MoRPh Correlation Code")
          mrsMapLayerCommon.surveyType
          crtAttributeLayer.createAutoLookup("scenarioName", "Scenario")
        ])
        crtFeatureLayer.createAttributeGroup("riverCondition", "River Condition", [
          crtAttributeLayer.createRange("preliminaryConditionScore", "Condition Score (Preliminary)", null, [
            { minValue: -5, maxValue: -4, color: crtMarkerColor.quality(0.0) }
            { minValue: -4, maxValue: -3, color: crtMarkerColor.quality(0.1) }
            { minValue: -3, maxValue: -2, color: crtMarkerColor.quality(0.2) }
            { minValue: -2, maxValue: -1, color: crtMarkerColor.quality(0.3) }
            { minValue: -1, maxValue:  0, color: crtMarkerColor.quality(0.4) }
            { minValue:  0, maxValue:  1, color: crtMarkerColor.quality(0.5) }
            { minValue:  1, maxValue:  2, color: crtMarkerColor.quality(0.6) }
            { minValue:  2, maxValue:  3, color: crtMarkerColor.quality(0.7) }
            { minValue:  3, maxValue:  4, color: crtMarkerColor.quality(0.8) }
            { minValue:  4, maxValue:  5, color: crtMarkerColor.quality(0.9) }
          ])
          crtAttributeLayer.createLookup("finalConditionClass", "Condition Class / Score (Final)", null, [
            { value: mrsRtaConditionClass.Good       , color: crtMarkerColor.quality(1.0)  , label: "Good / 5" }
            { value: mrsRtaConditionClass.FairlyGood , color: crtMarkerColor.quality(0.75) , label: "Fairly good / 4" }
            { value: mrsRtaConditionClass.Moderate   , color: crtMarkerColor.quality(0.5)  , label: "Moderate / 3" }
            { value: mrsRtaConditionClass.FairlyPoor , color: crtMarkerColor.quality(0.25) , label: "Fairly poor / 2" }
            { value: mrsRtaConditionClass.Poor       , color: crtMarkerColor.quality(0.0)  , label: "Poor / 1" }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("dimensions", "Dimensions", [
          crtAttributeLayer.createRange("shape", "River Shape", null, [
            { minValue:  0.0, maxValue:       0.5, color: crtMarkerColor.numeric(0/6) }
            { minValue:  0.5, maxValue:       1.0, color: crtMarkerColor.numeric(1/6) }
            { minValue:  1.0, maxValue:       1.5, color: crtMarkerColor.numeric(2/6) }
            { minValue:  1.5, maxValue:       2.0, color: crtMarkerColor.numeric(3/6) }
            { minValue:  2.0, maxValue:       5.0, color: crtMarkerColor.numeric(4/6) }
            { minValue:  5.0, maxValue:      10.0, color: crtMarkerColor.numeric(5/6) }
            { minValue: 10.0, maxValue: undefined, color: crtMarkerColor.numeric(6/6) }
          ])
          crtAttributeLayer.createRange("averageWidth", "Average Width", "m", [
            { minValue:  0.0, maxValue:       1.0, color: crtMarkerColor.numeric(0/6) }
            { minValue:  1.0, maxValue:       2.0, color: crtMarkerColor.numeric(1/6) }
            { minValue:  2.0, maxValue:       3.0, color: crtMarkerColor.numeric(2/6) }
            { minValue:  3.0, maxValue:       5.0, color: crtMarkerColor.numeric(3/6) }
            { minValue:  5.0, maxValue:      10.0, color: crtMarkerColor.numeric(4/6) }
            { minValue: 10.0, maxValue:      20.0, color: crtMarkerColor.numeric(5/6) }
            { minValue: 20.0, maxValue: undefined, color: crtMarkerColor.numeric(6/6) }
          ])
        ])
        crtFeatureLayer.createAttributeGroup("calculations", "Calculations", [
          crtAttributeLayer.createLookup("riverCategory", "River Category", null, [
            { value: mrsRtaRiverCategory.Navigable , color: crtMarkerColor.create("#777") , label: "Navigable" }
            { value: mrsRtaRiverCategory.Large     , color: crtMarkerColor.create("#eee") , label: "Large" }
            { value: mrsRtaRiverCategory.Other     , color: crtMarkerColor.create("#0dd") , label: "Other" }
          ])
          crtAttributeLayer.createRange("a1", "A1: Braiding Index", null, [
            { minValue: undefined , maxValue: 1.1       , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.1       , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createRange("a2", "A2: Sinuosity Index", null, [
            { minValue: undefined , maxValue: 1.05      , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.05      , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createRange("a3", "A3: Anabranching Index", null, [
            { minValue: undefined , maxValue: 1.05      , color: crtMarkerColor.quality(6 / 12) }
            { minValue: 1.05      , maxValue: 1.5       , color: crtMarkerColor.quality(5 / 12) }
            { minValue: 1.5       , maxValue: undefined , color: crtMarkerColor.quality(4 / 12) }
          ])
          crtAttributeLayer.createLookup("a4", "A4: Level of Confinement", null, [
            { value: mrsRtaLevelOfConfinement.Confined       , color: crtMarkerColor.quality(4 / 12) , label: "Confined" }
            { value: mrsRtaLevelOfConfinement.PartlyConfined , color: crtMarkerColor.quality(5 / 12) , label: "Partly confined" }
            { value: mrsRtaLevelOfConfinement.Unconfined     , color: crtMarkerColor.quality(6 / 12)  , label: "Unconfined" }
          ])
          crtAttributeLayer.createRange("a5", "A5: Reach Valley Gradient", null, [
            { minValue: undefined , maxValue: 0.01      , color: crtMarkerColor.quality(4 / 12) }
            { minValue: 0.01      , maxValue: undefined , color: crtMarkerColor.quality(6 / 12) }
          ])
          crtAttributeLayer.createAutoLookup("a6", "A6: Bedrock Reach?")
          mrsMapLayerCommon.particleSizeAttribute("a7", "A7: Coarsest Bed Material", true)
          mrsMapLayerCommon.particleSizeAttribute("a8", "A8: Average Bed Material", false)
          mrsRtaFeatureLayer.createRiverTypeAttribute("finalRiverType", "River Type")
        ])
      ]
    })

  return {
    create
  }

module.exports.factory "mrsMudSpotterLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  mrsMudSpotterSourceType
  mrsMudSpotterSourceSubType
  mrsMudSpotterSourceSize
  mrsMudSpotterFlow
  mrsMudSpotterSediment
) ->
  crtFeatureLayer.create({
    id: "MrsMudSpotter"
    name: "Mud Spotter"
    selectionRadius: 500
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("Site", "Site", [
        crtAttributeLayer.createAutoLookup("siteName", "Site Name")
      ])
      crtFeatureLayer.createAttributeGroup("Source", "Source", [
        crtAttributeLayer.createAutoLookup("riverName", "River", null)
        crtAttributeLayer.createAutoLookup("reachName", "Reach", null)
        crtAttributeLayer.createAutoLookup("siteName", "Site", null)
        crtAttributeLayer.createEnumLookup("sourceType", "Source Type", null, mrsMudSpotterSourceType)
        crtAttributeLayer.createEnumLookup("sourceSubType", "Source Sub-Type", null, mrsMudSpotterSourceSubType)
        crtAttributeLayer.createEnumLookup("sourceSize", "Source Size", null, mrsMudSpotterSourceSize)
        crtAttributeLayer.createEnumLookup("flow", "Flow of Water", null, mrsMudSpotterFlow)
        crtAttributeLayer.createEnumLookup("sediment", "Mud in Flowing Water", null, mrsMudSpotterSediment)
      ])
    ]
  })

module.exports.factory "mrsWildInvadersLayer", $DI (
  crtMarkerColor
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  crtFeatureLayer.create({
    id: "mrsWildInvaders"
    name: "Wild Invaders"
    atlasMapId: "mrsWildInvaders"
    defaultMapEngine: "atlas"
    selectionRadius: 50
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("inns", "Invasive Species", [
        crtAttributeLayer.createLookup("species", "Species", null, [
          { value: "HimalayanBalsam"  , color: crtMarkerColor.lookup(1, 10) , label: "Flora - Himalayan Balsam" }
          { value: "GiantHogweed"     , color: crtMarkerColor.lookup(2, 10) , label: "Flora - Giant Hogweed" }
          { value: "JapaneseKnotweed" , color: crtMarkerColor.lookup(3, 10) , label: "Flora - Japanese Knotweed" }
          { value: "FloatingPennywort", color: crtMarkerColor.lookup(4, 10) , label: "Flora - Floating Pennywort" }
          { value: "OtherFlora"       , color: crtMarkerColor.lookup(5, 10) , label: "Flora - Other" }
          { value: "SignalCrayfish"   , color: crtMarkerColor.lookup(6, 10) , label: "Fauna - Signal Crayfish" }
          { value: "KillerShrimp"     , color: crtMarkerColor.lookup(7, 10) , label: "Fauna - Killer Shrimp" }
          { value: "QuaggaMussel"     , color: crtMarkerColor.lookup(8, 10) , label: "Fauna - Quagga Mussel" }
          { value: "ChineseMittenCrab", color: crtMarkerColor.lookup(9, 10) , label: "Fauna - Chines Mitten Crab" }
          { value: "OtherFauna"       , color: crtMarkerColor.lookup(10, 10), label: "Fauna - Other" }
        ])
        crtAttributeLayer.createLookup("growthStage", "Growth Stage", null, [
          { value: "SeedlingOrLarvae" , color: crtMarkerColor.lookup(1, 4) , label: "Seedling or larvae" }
          { value: "Juvenile"         , color: crtMarkerColor.lookup(2, 4) , label: "Juvenile" }
          { value: "Adult"            , color: crtMarkerColor.lookup(3, 4) , label: "Adult" }
          { value: "DeadOrDying"      , color: crtMarkerColor.lookup(4, 4) , label: "Dead or dying" }
        ])
        crtAttributeLayer.createLookup("coverage", "Coverage", null, [
          { value: "VerySmall" , color: crtMarkerColor.lookup(1, 5) , label: "Very small (isolated specimens)" }
          { value: "Small"     , color: crtMarkerColor.lookup(2, 5) , label: "Small (<1 m2)" }
          { value: "Medium"    , color: crtMarkerColor.lookup(3, 5) , label: "Medium (1-5 m2)" }
          { value: "Large"     , color: crtMarkerColor.lookup(4, 5) , label: "Large (5-50 m2)" }
          { value: "VeryLarge" , color: crtMarkerColor.lookup(5, 5) , label: "Very large (>50 m2)" }
        ])
        crtAttributeLayer.createLookup("management", "Management", null, [
          { value: "NoSign"              , color: crtMarkerColor.lookup(1, 7) , label: "No sign of treatment" }
          { value: "RemovedManually"     , color: crtMarkerColor.lookup(2, 7) , label: "Removed by hand" }
          { value: "RemovedMechanically" , color: crtMarkerColor.lookup(3, 7) , label: "Removed mechanically" }
          { value: "DugOut"              , color: crtMarkerColor.lookup(4, 7) , label: "Dug out" }
          { value: "Sprayed"             , color: crtMarkerColor.lookup(5, 7) , label: "Sprayed" }
          { value: "StemInjected"        , color: crtMarkerColor.lookup(6, 7) , label: "Stem injected" }
          { value: "Other"               , color: crtMarkerColor.lookup(7, 7) , label: "Other treatment" }
        ])
      ])
    ]
  })
